<div class="devices-container view">
    <div class="title">{{ 'devices.title' | transloco }}</div>
    <div>
        <app-chart [config]="chartConfig" [hideButton]="true"></app-chart>
    </div>
    <div class="divider" [ngClass]="{'hide': !showDetailChart }"></div>
    <div [ngClass]="{'hide': !showDetailChart }">
        <app-chart [config]="chartDetailConfig" [isDetail]="true" [hideButton]="true"></app-chart>
    </div>
</div>